var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_6_hourglass"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m385.999 74.604v-37.975l-259.998-.002v37.975c0 59.979 28.879 116.799 78.581 153.279 8.971 6.585 14.33 16.997 14.33 28.125 0 11.106-5.326 21.518-14.281 28.087-50.767 37.242-78.633 94.554-78.633 153.304v37.976l259.998.002v-37.975c0-58.66-27.788-116.003-78.636-153.307-8.953-6.568-14.275-16.979-14.275-28.083v-.001c0-11.131 5.362-21.543 14.335-28.129 49.59-36.401 78.579-93.165 78.579-153.276z",
    fill: "#d8ecfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.421 227.878c49.59-36.399 78.578-93.163 78.579-153.275v-37.975l-259.998-.001 217.479.001v37.975c0 60.112-28.989 116.876-78.579 153.275-8.973 6.586-14.335 16.998-14.335 28.129v.001c0 11.104 5.323 21.515 14.275 28.083 50.849 37.304 78.637 94.647 78.636 153.307v37.975h42.52v-37.975c0-58.66-27.788-116.003-78.636-153.307-8.953-6.568-14.276-16.979-14.275-28.083v-.001c-.001-11.131 5.361-21.543 14.334-28.129z",
    fill: "#c4e2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.999 444.851v-5.051c0-25.113 12.988-48.88 36.137-67.931 18.029-14.838 40.671-22.653 63.861-22.653 23.19 0 45.832 7.816 63.862 22.654 23.15 19.053 36.138 42.819 36.138 67.931v5.051z",
    fill: "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.001 36.627h273.999c9.941 0 18-8.199 18-18.313 0-10.114-8.059-18.313-18-18.313h-273.999c-9.942 0-18.001 8.2-18 18.315.001 10.113 8.059 18.311 18 18.311z",
    fill: "#596c76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.001 512h273.999c9.941 0 18-8.199 18-18.313 0-10.114-8.059-18.313-18-18.313h-273.999c-9.942 0-18.001 8.2-18 18.315.001 10.113 8.059 18.311 18 18.311z",
    fill: "#596c76"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.998 330.173c-4.267 0-7.726-3.459-7.726-7.726v-10.302c0-4.268 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v10.302c0 4.267-3.459 7.726-7.726 7.726zm0-40.177c-4.267 0-7.726-3.459-7.726-7.726v-10.302c0-4.268 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v10.302c0 4.267-3.459 7.726-7.726 7.726zm0-40.177c-4.267 0-7.726-3.459-7.726-7.726v-10.302c0-4.268 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v10.302c0 4.267-3.459 7.726-7.726 7.726z",
    fill: "#feb137"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m157.742 97.956c4.958 33.021 20.345 63.479 43.98 87.534 14.38 14.636 33.94 22.783 54.28 22.783s39.899-8.147 54.279-22.782c23.634-24.053 39.021-54.512 43.979-87.535z",
    fill: "#feb137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.999 0h-52.564c9.941 0 18 8.199 18 18.313s-8.059 18.313-18 18.313h52.564c9.941 0 18-8.199 18-18.313s-8.059-18.313-18-18.313z",
    fill: "#465a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.999 475.373h-52.564c9.941 0 18 8.199 18 18.313 0 10.114-8.059 18.313-18 18.313h52.564c9.941 0 18-8.199 18-18.313 0-10.114-8.059-18.313-18-18.313z",
    fill: "#465a61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.161 389.308c4.172 15.664 6.317 31.825 6.317 48.091v7.453h12.52v-5.052c-.001-17.926-6.628-35.163-18.837-50.492z",
    fill: "#ffc344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.001 97.957c-4.414 35.001-18.659 68.034-40.985 95.544 3.271-2.402 6.376-5.069 9.264-8.008 23.634-24.053 39.021-54.512 43.979-87.535h-12.258z",
    fill: "#f6ab31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.6022ec035394a5ad8819385e879e72a5.svg";
export { ForwardRef as ReactComponent };